export const BOUNDRY = {
  left: 50,
  top: 50,
  right: 86, //adjusted for width of star object (+36)
  bottom: 90 //adjusted for control panel
};

export const PLANET_COLORS = ['#FF31C1', '#AA7218', '#F9C311', '#F1C277', '#AAD3D3'];
